import { makeStyles } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import React, { useEffect, useState } from "react";
import CustomInputText from "./CustomInputText";
import MDButton from "./MDButton";
import CustomImageUploader from "./CustomImageUploader";
import MDBox from "./MDBox";
import MDInput from "./MDInput";
import { AddPinCall, DeletePinCall, EditPinCall } from "../redux/api/title.api";
import { basicURL } from "../apiManager/APIConfig";
import { store } from "../redux/store";
import axios from "axios";

const CustomDrawer = ({ fetchSlide, lang, slide_id, data, open, toggleDrawer }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(data?.files?.[0]?.url);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    // const extractedTitle = data?.pinLocalizations?.filter((e) => e.field === "title");
    // const extractedBody = data?.pinLocalizations?.filter((e) => e.field === "body");
    setTitle(data?.title);
    setDescription(data?.body);
  }, [data]);

  const onChangeTitle = (e) => {
    setTitle(e.target.value); // Update password state
  };

  const onChangeDescription = (e) => {
    setDescription(e.target.value); // Update password state
  };
  const classes = useStyles();

  const handlePhotoMaterial = async (file) => {
    setImage(file);

    if (file) {
      try {
        setShowLoader(true);
        // Handle `.zip` file upload
        const formdata = new FormData();
        formdata.append("file", file);
        formdata.append("entity_type", "pin");
        formdata.append("entity_id", data?.id);
        formdata.append("destination", "pins");
        formdata.append("folder_name", "pins");

        const access_token = store.getState().auth?.access_token;
        let myHeaders = new Headers();
        myHeaders.append("Authorization", access_token);

        myHeaders = {
          Authorization: access_token,
        };

        const response = await axios.post(`${basicURL}/file/upload`, formdata, {
          headers: myHeaders,
          onUploadProgress: (progressEvent) => {
            // Calculate the progress percentage
            const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            // setUploadPercentage(percent);
          },
        });
        setShowLoader(false);
        // setImage(`${basicURL}/${response?.data?.extracted_files?.[1]?.path}`);

        console.log(
          "ZIP file uploaded:",
          `${basicURL}/${response?.data?.extracted_files?.[1]?.path}/{z}/{x}/{y}.png`
        );
        window.location.reload();
      } catch (error) {
        console.error("Upload error:", error);
      }
    }
  };

  const save = async () => {
    if (data?.id) {
      const body = {
        id: data?.id,
        title,
        lang,
        type: "his",
        slide_id,
        body: description,
        locations: JSON.stringify({ data }),
      };
      await EditPinCall(body);
    } else {
      const body = {
        title,
        lang,
        type: "his",
        slide_id,
        body: description,
        locations: JSON.stringify({ data }),
      };
      await AddPinCall(body);
    } //fetch
    await fetchSlide();
    window.location.reload();
  };

  const deletePin = async () => {
    const pin_id = data?.id;
    const confirmation = window.confirm(
      "Are you sure you want to delete this pin? if you delete this pin all footage that you uploaded for this specific pin will be removed permanently."
    );
    if (confirmation) {
      await DeletePinCall(pin_id);
      window.location.reload();
    }
  };

  return (
    <Drawer
      className={classes.drawer}
      variant="temporary"
      anchor="right"
      open={open}
      onClose={() => toggleDrawer(false)}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div className={classes.list}>
        <MDBox component="form" role="form">
          <MDBox mt={5} mb={2}>
            <MDInput value={title} onChange={onChangeTitle} type="text" label="Title" fullWidth />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              onChange={onChangeDescription}
              multiline
              rows={10}
              value={description}
              type="text"
              label="Description"
              fullWidth
            />
          </MDBox>
        </MDBox>
        {data?.id ? (
          <CustomImageUploader
            value={image}
            files={data?.files}
            setFile={handlePhotoMaterial}
            setImage={setImage}
          />
        ) : (
          <>
            Please first add a title and description for this pin, then you can upload files for it
            using the plus button.
          </>
        )}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <MDButton
            disabled={!description && !title}
            style={{ marginTop: 20 }}
            color="info"
            variant="contained"
            onClick={() => save()}
          >
            Save
          </MDButton>
          <MDButton
            disabled={!data?.id}
            style={{ marginTop: 20 }}
            color="error"
            variant="contained"
            onClick={() => deletePin()}
          >
            Delete
          </MDButton>
        </div>
      </div>
    </Drawer>
  );
};

export default CustomDrawer;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: "300px",
    flexShrink: 0,
  },
  drawerPaper: {
    width: "300px",
    backgroundColor: "#f5f5f5",
    marginHorizontal: 20,
  },
  toolbar: theme.mixins.toolbar,
  list: {
    margin: "0 20px",
  },
}));
